export enum TaskActionType {
    Any = 1,
    Form,
    Document
  }